import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../Containers/Config/index.js';
import { SUPERSET_VERTICAL_TABLE, SUPERSET_VERTICAL_TABLE_ERROR, SUPERSET_VERTICAL_TABLE_SUCCESS } from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* supersetVerticalTable({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: SUPERSET_VERTICAL_TABLE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPERSET_VERTICAL_TABLE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPERSET_VERTICAL_TABLE_ERROR, payload: error });
  }
}

export function* watchSupersetVerticalTable() {
  yield takeEvery(SUPERSET_VERTICAL_TABLE, supersetVerticalTable);
}

function* supersetVerticalTableSaga() {
  yield all([fork(watchSupersetVerticalTable)]);
}

export default supersetVerticalTableSaga;
